import { useCallback } from "react";
import { Outlet } from "react-router";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Drawer from "@mui/material/Drawer";

import { useGetPolicyWithPricingRetry } from "@hooks/policies/useGetPolicyWithPricingRetry";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { PolicyDetailsContent } from "./PolicyDetailsContent";
import { PolicyDetailsProvider } from "./PolicyDetailsContext";

export function PolicyDetails() {
  const navigate = useNavigate();

  const { policyLocator } = useParams();
  const { canMarkRenewalAsPaid } = useAccessPattern();
  const [searchParams] = useSearchParams();

  const { data, loading, error, refetch } = useGetPolicyWithPricingRetry(
    policyLocator,
    canMarkRenewalAsPaid
  );

  const onClose = useCallback(() => {
    navigate({
      pathname: "../",
      search: createSearchParams(searchParams).toString(),
    });
  }, [searchParams]);

  return (
    <PolicyDetailsProvider
      refetchPolicy={refetch}
      policy={data?.getPolicy}
      loading={loading}
      error={!!error}>
      <Drawer
        anchor="right"
        open
        onClose={onClose}
        PaperProps={{
          sx: {
            width: {
              sm: "65%",
              md: "80%",
              lg: "71%",
            },
            maxWidth: "960px",
            minWidth: "350px",
          },
        }}>
        <PolicyDetailsContent onClose={onClose} />
      </Drawer>
      <Outlet />
    </PolicyDetailsProvider>
  );
}
